import type React from 'react';
import { useState, useEffect } from 'react';

const useDebounceClick = (): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (!isClicked) {
      return;
    }
    const timer = setTimeout(() => setIsClicked(false), 2000);

    return () => clearTimeout(timer);
  }, [isClicked]);

  return [isClicked, setIsClicked];
};

export default useDebounceClick;
